// extracted by mini-css-extract-plugin
export default {"header":"Header_header__YJUms","nav":"Header_nav__F+fMt","pages":"Header_pages__DN226","links":"Header_links__+0kM-","middle-link":"Header_middle-link__EcoQb"};